import React from "react";
import "./AboutPage.css";
import PlaceHolder from "../components/PlaceHolder";
import Name from "../components/Name";
import zihaoAbout from "../resource/zihao1.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faJs,
  faReact,
  faPython,
  faJava,
} from "@fortawesome/free-brands-svg-icons";
import backgroundImage from "../resource/background4.png";
function AboutPage(props) {
  return (
    <div className="aboutPage">
      <img
        src={zihaoAbout}
        alt=""
        style={{
          height: "730px",
          width: "1004px",
          display: "block",
          // position: "absolute",
          // top: "0",
          // left: "200px",
        }}
      />
      <PlaceHolder
        styles={{
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "start",
          opacity: 1.0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "5px",
          marginLeft: "5px",
          paddingRight: "125px",
          marginBottom: "0px",
          height: "730px",
        }}
      >
        <PlaceHolder
          styles={{
            opacity: 1.0,
            marginTop: "20px",
            paddingLeft: "40px",
            display: "flex",
            marginBottom: "5px",
            justifyContent: "center",
          }}
        >
          <Name
            text={"About"}
            styles={{
              color: "#1a1aff",
              paddingLeft: "10px",
              fontFamily: "Rubik, sans-serif",
              fontSize: "45px",
              fontWeight: 500,
            }}
          />
        </PlaceHolder>
        <PlaceHolder
          styles={{
            opacity: 1.0,
            alignItems: "start",
            justifyContent: "start",
            paddingLeft: "10px",
            display: "flex",
            marginBottom: "1px",
          }}
        >
          <Name
            text={"Name:"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              marginTop: "20px",
            }}
          />

          <Name
            text={"Cheng Zihao"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "280px",
            }}
          />
        </PlaceHolder>

        <PlaceHolder
          styles={{
            opacity: 1.0,
            alignItems: "start",
            justifyContent: "start",
            paddingLeft: "10px",
            display: "flex",
            marginBottom: "1px",
          }}
        >
          <Name
            text={"Age:"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              marginTop: "30px",
            }}
          />
          <Name
            text={"23"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "360px",
              top: "140px",
            }}
          />
        </PlaceHolder>
        <PlaceHolder
          styles={{
            opacity: 1.0,
            alignItems: "start",
            justifyContent: "start",
            paddingLeft: "10px",
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Name
            text={"School:"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              marginTop: "50px",
            }}
          />
          <Name
            text={"NUS (Bachelor of Computing in Computer Science)"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "120px",
              top: "206px",
              width: "530px",
            }}
          />
        </PlaceHolder>
        <PlaceHolder
          styles={{
            opacity: 1.0,
            alignItems: "start",
            justifyContent: "start",
            paddingLeft: "10px",
            display: "flex",
            marginBottom: "60px",
          }}
        >
          <Name
            text={"Skills:"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              marginTop: "95px",
            }}
          />
          <FontAwesomeIcon
            icon={faJs}
            size="3x"
            style={{
              color: "#74C0FC",
              position: "absolute",
              right: "480px",
              top: "335px",
            }}
          />
          <Name
            text={"JavaScript"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "23px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "50px",
              width: "400px",
              top: "330px",
              right: "200px",
            }}
          />
          <FontAwesomeIcon
            icon={faReact}
            size="3x"
            style={{
              color: "#74C0FC",
              position: "absolute",
              right: "475px",
              top: "400px",
            }}
          />
          <Name
            text={"React, React Native"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "23px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "90px",
              width: "400px",
              top: "388px",
              right: "150px",
            }}
          />
          <FontAwesomeIcon
            icon={faPython}
            size="3x"
            style={{
              color: "#FFD43B",
              position: "absolute",
              right: "480px",
              top: "455px",
            }}
          />
          <Name
            text={"Python, NymPy, Pandas"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "23px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "115px",
              width: "400px",
              top: "445px",
              right: "126px",
            }}
          />
          <FontAwesomeIcon
            icon={faJava}
            size="3x"
            style={{
              color: "red",
              position: "absolute",
              right: "482px",
              top: "510px",
            }}
          />
          <Name
            text={"Java"}
            styles={{
              color: "black",
              paddingLeft: "50px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "23px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "0px",
              width: "400px",
              top: "505px",
              right: "240px",
            }}
          />
        </PlaceHolder>
        <PlaceHolder
          styles={{
            opacity: 1.0,
            alignItems: "start",
            justifyContent: "start",
            paddingLeft: "10px",
            display: "flex",
            marginBottom: "10px",
          }}
        >
          <Name
            text={"Grade:"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              marginTop: "235px",
            }}
          />
          <Name
            text={"CAP: 4.75"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "30px",
              width: "400px",
              top: "573px",
              right: "360px",
            }}
          />
        </PlaceHolder>
        <PlaceHolder
          styles={{
            opacity: 1.0,
            alignItems: "start",
            justifyContent: "start",
            paddingLeft: "10px",
            display: "flex",
            marginBottom: "10px",
          }}
        >
          <Name
            text={"Strength:"}
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: 700,
              marginTop: "230px",
            }}
          />
          <Name
            text={
              "🔍problem-solving, 🧠critical thinking, 📈analytical skills, 🔥passionate about work, 🤼team player"
            }
            styles={{
              color: "black",
              paddingLeft: "10px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "18px",
              fontWeight: 700,
              position: "absolute",
              marginLeft: "150px",
              width: "550px",
              top: "632px",
              textAlign: "left",
              right: "70px",
            }}
          />
        </PlaceHolder>
      </PlaceHolder>
    </div>
  );
}
export default AboutPage;
